export const OVERRIDE_ACCOUNTING_SOFTWARES = ["Other", "IdontKnow", "None"]
